import React, { useContext, useEffect, useRef } from "react";
import styles from "./Header.module.scss";
import PathContext from "../../context/path";
import StateContext from "../../context/states";
const Header = () => {
  const path = useContext(PathContext);
  const state = useContext(StateContext);
  const { isMobile, page } = state;
  const refWrap = useRef(null);
  useEffect(() => {
    const wrap = refWrap.current;
    if (isMobile && styles[`wrap_${page}`] !== undefined) {
      wrap.classList = `${styles.wrap} ${styles[`wrap_${page}`]}`;
    }
    return () => {
      wrap.classList = `${styles.wrap}`;
    }
  }, [isMobile, page])
  return (
    <>
      <div className={styles.wrap} ref={refWrap}>
        <div className={styles.col}>
          <a href='/' className={styles.logo}>
            <img src={`${path}/img/logo.svg`} alt="" />
          </a>
        </div>
        <div className={styles.col}>
          <div className={styles.desc}>спецпроект</div>
          <div className={styles.title}>Здравствуйте, это вы</div>
        </div>
        <div className={styles.col}></div>

      </div>
    </>
  );

}

export default Header;
